import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../utils/mq';
import GoogleNewsLogo from '../icons/googleNews';
import WhatsAppLogo from '../icons/whatsAppLogo';
import { useTranslation } from '../utils/translation';

const SubscribeWrapper = styled.div`
  align-items: center;
  background: none;
  border: solid 1px #ddd;
  border-radius: 6px;
  display: -ms-flexbox;
  display: flex;
  gap: 8px;
  line-height: 26px;
  margin: var(--spacer) 0;
  padding: var(--spacer-fluid);
`;

const SubscribeWrapperText = styled.span`
  line-height: 1.84;
`;

const SubscribeLogos = styled.div`
  display: flex;
  gap: 10px;
  margin: 0 0 0 auto;

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      flex-direction: column;
    `,
  )}
`;

const Logo = styled.div`
  height: auto;
  width: 75px;

  &:first-of-type {
    position: relative;
    top: 6px;
  }

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      height: 50px;
      width: 50px;

      svg {
        width: 45px;
        height: 45px;
      }
    `,
  )}
`;

const Cta = styled.a`
  color: var(--title-foreground);
  font-weight: 700;
  gap: 10px;
  transition: color 0.3s;
  width: 100%;

  &:hover {
    color: var(--theme-palette-primary);
  }
`;

export function GoogleNewsSubscribe() {
  const t = useTranslation();

  return (
    <SubscribeWrapper>
      <SubscribeWrapperText>
        {t('design.subscribe.user')}
        <Cta
          href="https://news.google.com/publications/CAAqBwgKMNyJkwswwaKoAw?hl=fr&gl=FR&ceid=FR%3Afr"
          rel="nofollow"
          target="_blank"
        >
          {t('design.subscribe.gnews')}
        </Cta>
        {t('design.subscribe.or')}
        <Cta href="https://whatsapp.com/channel/0029VaFN2Nm3bbV7Nzel1P2B" rel="nofollow" target="_blank">
          {t('design.subscribe.whatsapp')}
        </Cta>
        &nbsp;?
        <br />
        {t('design.subscribe.follow')}
      </SubscribeWrapperText>
      <SubscribeLogos>
        <Logo>
          <GoogleNewsLogo width={68} height={58} color={null} />
        </Logo>
        <Logo>
          <WhatsAppLogo width={68} height={58} color={null} />
        </Logo>
      </SubscribeLogos>
    </SubscribeWrapper>
  );
}
